/**
 * 取引種別
 */
export type CorporateDealType =
  | "1" // コード
  | "2" // Zipファイル
  | "3" // GithubURL


/** 取引種別：コード */
export const Code = "1" as CorporateDealType;
/** 取引種別：Zipファイル*/
export const ZipFile = "2" as CorporateDealType;
/** 取引種別：GitHUbURL */
export const GithubUrl = "3" as CorporateDealType;